import { createContext, useContext } from 'react';
import type { Locale } from '@/strings/types';
import { STRINGS_EN, type StringsEN } from '@/strings/en';
import { STRINGS_AR } from '@/strings/ar';

export interface LocaleContextValue {
  locale: Locale;
  dir: 'ltr' | 'rtl';
  strings: StringsEN;
}

export const LocaleContext = createContext<LocaleContextValue | null>(null);

export function useLocale(): LocaleContextValue {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error('useLocale must be used within LocaleContext.Provider');
  return ctx;
}

export function getStringsFor(locale: Locale): StringsEN {
  return locale === 'ar' ? STRINGS_AR : STRINGS_EN;
}

export function getDirFor(locale: Locale): 'ltr' | 'rtl' {
  return locale === 'ar' ? 'rtl' : 'ltr';
}
